import { http } from 'common/helpers/axios/axios-helper';
import { BaseHttpResponse } from 'common/interfaces/base-http-response.model';
import { PagedResult, Step, NotificationChannel, UpsertUserNotificationSettings, UserNotificationSettings as UserChannels } from '../model/step';

const basePath = '/Notification';

async function getUserStepSettings(userId: number, query?: { pageNumber: number, pageSize: number, orderBy?: string, order?: 'asc' | 'desc', term?: string, departmentId?: number }): Promise<BaseHttpResponse<PagedResult<Step>> | undefined> {
    const queryString = Object.entries(query || {}).map(([key, value]) => `${key}=${value}`).join('&');
    return await http.get<PagedResult<Step>>(`${basePath}/user/${userId}/step?${queryString}`)
}

async function getUserNotificationSettings(userId: number): Promise<BaseHttpResponse<UserChannels> | undefined> {
    return await http.get<UserChannels>(`${basePath}/user/${userId}`)
}

async function upsertUserNotificationSettings(body: UpsertUserNotificationSettings): Promise<BaseHttpResponse<UserChannels> | undefined> {
    return await http.post<UserChannels>(`${basePath}/user/${body.userId}`, body);
}

async function getTenantEnabledChannels(): Promise<BaseHttpResponse<{
    enabledChannels: number[];
    tenantId: string;
}> | undefined> {
    return await http.get(`${basePath}/tenant/channels`);
}

export const NotificationService = {
    getUserStepSettings,
    getUserNotificationSettings: getUserNotificationSettings,
    upsertUserNotificationSettings,
    getTenantEnabledChannels
}